import React, { useState } from "react";
import { includes, xor } from "lodash";
import { ChevronDown } from "@sonder/ui/source/icons";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import {
  FilterButtonList,
  FilterDropdownContent,
  FilterFooter,
  FilterTextArea,
} from "@sonder/ui/source/styled/fragments/GenericFilters";
import { Link } from "@sonder/ui/source/styled/fragments/Link";
import { useSegmentQueue } from "tasks/hooks";
import { setFilters } from "team/actions";
import { SquadFilterGroupItem } from "team/components/SquadFilterGroupItem";
import { useStore } from "team/store";
import { SquadTag } from "typings/globalGQLTypes";

export const SquadFilters = () => {
  const [search, setSearch] = useState("");
  const {
    state: { filters: globalFilters },
    dispatch,
  } = useStore();
  const pushToSegmentQueue = useSegmentQueue(globalFilters);

  const { squads } = globalFilters;
  const totalSelected = (squads && squads.length) || 0;

  const filteredSquads =
    search !== ""
      ? Object.values(SquadTag).filter(tag =>
          tag.toLowerCase().includes(search.replace(" ", "").toLowerCase()),
        )
      : Object.values(SquadTag);

  const onClickOption = (squad: SquadTag, isChecked: boolean) => {
    const newSquads = xor(squads, [squad]);
    dispatch(setFilters({ squads: newSquads }));
    pushToSegmentQueue({
      eventName: "squad_filters",
      action: "click",
      element: `squad_filters-${squad}`,
      props: { nextValue: !isChecked ? "selected" : "deselected" },
      commonProps: {},
    });
  };

  const renderSquad = (squad: SquadTag) => {
    const isChecked = includes(squads, squad);
    return (
      <SquadFilterGroupItem
        isChecked={isChecked}
        key={squad}
        squad={squad}
        onClick={() => onClickOption(squad, isChecked)}
      />
    );
  };
  return (
    <Dropdown
      trigger={
        <Button fullWidth iconRight type="button">
          Squads
          {totalSelected > 0 && ` (${totalSelected})`}
          <ChevronDown />
        </Button>
      }
    >
      {({ isOpen: isPortalOpen }) =>
        isPortalOpen && (
          <FilterDropdownContent align="left">
            <FilterTextArea
              autoFocus
              placeholder="Search squad types"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <FilterButtonList>
              {filteredSquads.map(renderSquad)}
            </FilterButtonList>
            <FilterFooter>
              {`${totalSelected || 0} Selected`}
              {totalSelected > 0 && (
                <Link
                  onClick={() => {
                    requestAnimationFrame(() =>
                      dispatch(setFilters({ squads: [] })),
                    );
                  }}
                >
                  Clear selected
                </Link>
              )}
            </FilterFooter>
          </FilterDropdownContent>
        )
      }
    </Dropdown>
  );
};
